module.exports = __webpack_public_path__ + "r-v3/img/ml_11_00.4cb130a5.jpg";